<template>
  <div>
    <div class="searchBar">
      <div class="bar_item">
        <div class="search_title">目的地</div>
        <div class="search_content">
          <el-autocomplete
            style="width: 600px"
            @keyup.enter.native="query"
            v-model="destination"
            value-key="city_name_cn"
            value="city_code || id"
            :fetch-suggestions="querySearchAsync"
            placeholder="城市／酒店"
            @select="handleSelect"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.city_name_cn || item.name_cn }}</div>
              <!--              <span class="addr">{{ item.city_code }}</span>-->
            </template>
          </el-autocomplete>
        </div>
      </div>

      <div class="bar_item" style="flex-direction: row">
        <div>
          <div class="search_title">
            <div class="in_date" style="padding-left: 33px">
              入住日期
            </div>
            <div class="out_date" style="padding-left: 9px">
              离店日期
            </div>
          </div>
          <div class="search_content fl-bet">
            <div class="fl">
              <el-date-picker
                prefix-icon="none"
                v-model="HotelDate"
                type="daterange"
                @change="checkDate"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="p_8 f-w600" style="display: flex;align-items: flex-end;">
          {{ getNightDifference(HotelDate[0], HotelDate[1]) }}晚
        </div>
      </div>

      <div class="fl fl-bet bar_item show" id="drop" @click="showPop" style="flex-direction: row">

        <div class="fl">
          <div class="fl" style="width: 65px;flex-direction: column">
            <div class="p_8">
              房间数
            </div>
            <div class="f-w600">
              {{ roomParameters.room }}间
            </div>
          </div>

          <div class="fl">
            <div class="fl" style="flex-direction: column;">
              <div class="p_8">每间入住</div>
              <div style="position: relative" class="f-w600">
                {{ roomParameters.adult }}成人{{ roomParameters.children }}儿童
                <div v-show="showBox" class="drop-down show" id="drop_list" ref="drop">
                  <div class="drop_list_item">
                    <div>房间数</div>
                    <div>
                      <el-input-number size="mini" :min="1" :max="5" v-model="roomParameters.room"></el-input-number>
                    </div>
                  </div>
                  <div class="drop_list_item">
                    <div>成人(每间)</div>
                    <div>
                      <el-input-number size="mini" :min="1" :max="10" v-model="roomParameters.adult"></el-input-number>
                    </div>
                  </div>
                  <div class="drop_list_item">
                    <div>儿童(每间)</div>
                    <div>
                      <el-input-number size="mini" :min="0" :max="2" @change="changeChild"
                                       v-model="roomParameters.children"></el-input-number>
                    </div>
                  </div>
                  <div class="child" v-show="roomParameters.ChildAgeDetails.length > 0">
                    <div>儿童年龄（以入住当天计算）</div>
                    <div class="child_drop">

                      <el-select v-model="roomParameters.ChildAgeDetails[index]"
                                 v-for="(item, index) in roomParameters.children" :key="index" placeholder="请选择">
                        <el-option
                          v-for="item in 17"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fl" style="align-items: flex-end;padding-bottom: 10px">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="bar_item">
        <div class="search_title">
          国家
        </div>
        <div class="search_content fl-bet al_cent">
          <div class="fl">
            <el-autocomplete
              popper-class="my-autocomplete"
              v-model="CountryText"
              :fetch-suggestions="querySearch"
              :placeholder="$store.state.country.name"
              @select="handleSelectCountry">
              <template slot-scope="{ item }">
                <div class="name" style="width: 230px">{{ item.name }}</div>
              </template>
            </el-autocomplete>
          </div>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="bar_item">
        <div class="hotel-search-button" @click="query">查询</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getNightDifference} from "@/utils/index"
import {city_list, country, pc_search_keywords} from "@/api/index";
import {mapMutations, mapState} from 'vuex'

export default {
  name: "searchBar",
  data() {
    return {
      CountryText: this.$store.state.country.name || '',
      countryList: [],
      restaurants: [],
      destination: this.$store.state.destination.name_cn || this.$store.state.destination.city_name_cn || '',
      timeout: null,
      HotelDate: this.$store.state.in_out_date || [],
      showBox: false,
      cityList: [],
      roomParameters: {
        room: 1,
        adult: 1,
        children: 0,
        ChildAgeDetails: []
      },
      pickerOptions: {
        disabledDate: time => {
          let num = 1000 * 60 * 60 * 24 * 90;
          const date = new Date(Date.now() + num);
          return time.getTime() <= new Date().getTime() || time.getTime() >= date;
        }
      }
    }
  },
  created() {
    this.getCountry();
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['in_out_date']),
  },
  watch: {
    "roomParameters": {
      handler(newValue, oddValue) {
        this.$store.commit('setRoomParameters', newValue);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['setDate', 'setCountry']),
    getNightDifference,
    init() {
      this.closePop();
      this.initDate();
      // this.getCityList();
      this.roomParameters = this.$store.state.roomParameters;
    },
    query() {
      let selectItem = this.restaurants[0];
      this.handleSelect(selectItem);
      this.$emit('query');
    },
    changeChild(val) {
      let len = this.roomParameters.ChildAgeDetails.length;
      if (len > val) {
        for (let i = 0; i < (len - val); i++) {
          this.roomParameters.ChildAgeDetails.pop();
        }
      } else if (len < val) {
        for (let i = 0; i < (val - len); i++) {
          this.roomParameters.ChildAgeDetails.push(1);
        }
      }
    },
    closePop() {
      document.addEventListener('click', (e) => {
        // 如果当前点击的这个对象是这个模态框的话
        if ((e.target).closest('.show')) {
          //  那么这个模态框还是显示的
          this.showBox = true
        } else if (!(e.target).closest('.show')) {
          // 如果当前点击的这个对象是这个show按钮以外的对象，那么这个模态框就隐藏
          this.showBox = false
        }
      })
    },
    showPop() {
      this.showBox = !this.showBox;
    },
    handleSelectCountry(item) {
      this.setCountry(item);
      this.CountryText = item.name;
    },
    // --------------------------------------------------------------
    // 国家列表
    async getCountry() {
      this.$loads.show();

      try {
        let {data, code, msg} = await country();
        if (code == 0) {
          this.$loads.hidden();
          this.countryList = data.data;

        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          })
        }
      } catch (e) {
        this.$loads.hidden();
      }
    },
    // 城市列表
    async getCityList() {
      this.$loads.show();

      try {
        let {data, code, msg} = await city_list();
        if (code == 0) {
          this.$loads.hidden();
          this.cityList = data.city_list;

        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          })
        }
      } catch (e) {
        this.$loads.hidden();
      }
    },
    async searchKey(keyword) {
      try {
        let {data, code, msg} = await pc_search_keywords({
          keywords: keyword,
          check_in_date: this.in_out_date[0],
          check_out_date: this.in_out_date[1]
        });

        if (code == 0) {
          return data;
        } else {
          this.$message({
            message: msg
          })
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 国家
    querySearch(queryString, cb) {
      var restaurants = this.countryList;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    async querySearchAsync(queryString, cb) {
      this.restaurants = await this.searchKey(queryString);
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(restaurants);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        if (state.city_name_cn) {
          return (state.city_name_cn.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        } else if (state.name_cn) {
          return (state.name_cn.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      };
    },
    handleSelect(item) {
      this.destination = item.name_cn || item.city_name_cn || '';
      this.$store.commit('setDestination', item);
    },
    checkDate(e) {
      this.setDate(e)
    },
    // 初始化时间
    initDate() {
      this.HotelDate = this.$store.state.in_out_date;
    }
  }
}
</script>

<style>
.my-autocomplete {
  width: 230px !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-range-editor--medium .el-range-input {
  font-weight: 600;
}

::v-deep .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
  width: 232px;
}

::v-deep .el-range-editor--medium .el-range__close-icon, .el-range-editor--medium .el-range__icon {
  display: none;
}

::v-deep .el-range-input {
  font-size: 14px;
  font-weight: 600;
}

::v-deep.el-autocomplete-suggestion {
  margin-top: 24px !important;
}

::v-deep .el-input__inner {
  border: none;
  font-size: 14px !important;
  font-weight: 600;
  color: #000000;
  padding: 0;
}

::v-deep .el-autocomplete-suggestion {
  width: 500px !important;
}

.searchBar {
  display: flex;
  font-size: 14px;
  box-shadow: 0 2px 8px 0 rgba(152, 158, 175, .32);
  border-radius: 8px;
  background-color: #fff;

  .bar_item {
    border-left: 1px solid #ced4da;
    padding: 12px 16px;
    width: 330px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .search_content {
      display: flex;
      font-weight: 600;
    }

    .search_title {
      display: flex;

      color: #676f86;
      font-weight: 400;

      > div {
        flex: 1;
      }
    }
  }

  > div:first-child {
    border-left: none;
  }

  > div:nth-child(3) {
    width: 260px;
  }

  > div:nth-child(4) {
    width: 170px;
  }

  > div:nth-child(5) {
    flex: 1;

    .hotel-search-button {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 52px;
      width: 62px;
      box-shadow: 0 3px 8px 0 #beefe4;
      border-radius: 8px;
      color: #fff;
      background: #1DCD97;
      border-color: #1DCD97;
      text-shadow: 0 -1px 0 rgba(0, 0, 0, .12);
    }
  }
}

.fl-bet {
  justify-content: space-between;
}

.fl {
  display: flex;
}

.p_8 {
  padding-bottom: 8px;
}

.f-w600 {
  font-weight: 600;
}

.drop-down {
  position: absolute;
  background-color: #fff;
  width: 250px;
  top: 46px;
  left: -92px;
  border-radius: 6px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #7a7a7a;
  z-index: 2023;
  transition: all .3s;

  .drop_list_item {
    display: flex;
    justify-content: space-between;
  }
}

.al_cent {
  align-items: center;
}

.child_drop {
  padding: 10px 20px;
  display: flex;
  gap: 15px;
}
</style>
